import { Url } from "./Url.service";
import { HandleResponse, AuthHeader } from "../_helpers";

export const MultiEmpresaService = {
    obtenerDatosFacturacion,
    obtenerDatosTransferencia,
    crearSolicitud,
    obtenerMisSolicitudes,
    obtenerProductosFrecuentes,
    obtenerProductosAleatorios,
    obtenerSolicitudPorId,
    obtenerSolicitudPorIdAdmin,
    eliminarSolicitud,
    obtenerSolicitudesAdmin,
    resumenSolicitudes,
    aprobarSolicitud,
    rechazarSolicitud,
    exportarSolicitudesExcel,
    descargarComprobante,
    pagarSolicitudMultiempresa,
    obtenerTodasLasSolicitudesJefe,
    obtenerMisSolicitudesVendedor,


    procesarPagoClienteCorreo,
    subirComprobanteCliente,


    getPerfilEmpresa,
    getslugEmpresa,
    getEmpresasMultiempresa,
    getEmpresasyPerfiles,
    getEmpresasAsociadas,


    obtenerProductos,
    buscarProductosAutocomplete,
    obtenerProductoPorId,
    categoriasPorEmpresa,
    subcategoriasPorEmpresa,


    obtenerCarroF,
    agregarProducto,
    actualizarProducto,
    eliminarProducto,

    ordenesMultiempresa,
    procesarOrdenesMultiempresa,
    aceptar_orden,
    rechazar_orden_unidad,
    despachar_orden_multiempresa,
    aceptar_orden_multiempresa,
    orden_logistica_multiempresa,
    logisticaVentas,
    retirar_logistica_multiempresa,
    entregada_logistica_multiempresa,
    devueltas_logistica_multiempresa,
    cambiar_cantidad_multiempresa,
    rechazar_producto_logistica_multiempresa,
    exportarOrdenesExcel,
    actualizar_stock_desde_solicitud,
    crear_stock_desde_solicitud,

    //clientes
    MasSolicitadosCliente,
    obtenerMisSolicitudesCliente,
    SolicitudClientePorId,
    obternerConfiguracionUsuario,
    obtenerTiposDocumentosCredito,
    crearSolicitudCredito,
    obtenerSolicitudesApertura,
    obtenerDetalleSolicitudApertura,
    evaluarSolicitudApertura,
    obtenerPlazosEmpresas,

    //Core empresas externas
    crearSolicitudMultiTenant,
    aprobarSolicitudMultiTenant,
    rechazarSolicitudMultiTenant,
};

function obtenerDatosFacturacion(id_usuario) {
    return fetch(
        `${Url}multiempresa/datos_facturacion/${id_usuario}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

async function obtenerDatosTransferencia(id_empresa) {
    try {
        const response = await fetch(`${Url}multiempresa/datos_transferencias/${id_empresa}`, {
            method: "GET",
            headers: {
                ...AuthHeader(),
                "Accept": "application/json"
            }
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || "Error al obtener los datos de transferencia");
        }

        return result.data;

    } catch (error) {
        console.error("Error en obtenerDatosTransferencia:", error);
        throw error;
    }
}

/**
 * genera la orden
 */
function crearSolicitud(data) {
    return fetch(
        `${Url}multiempresa/crear_solicitud`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            },
            body: JSON.stringify(data)
        }
    ).then(HandleResponse);
}

function procesarOrdenesMultiempresa(data) {
    return fetch(
        `${Url}multiempresa/ordenes/procesar`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            },
            body: JSON.stringify(data)
        }
    ).then(HandleResponse);
}

function aceptar_orden(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...AuthHeader()
        },
        body: JSON.stringify(data),
    };
    return fetch(`${Url}multiempresa/aceptar_orden`, requestOptions)
        .then(HandleResponse)
        .then((response) => {
            return response;
        });
}

function rechazar_orden_unidad(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...AuthHeader()
        },
        body: JSON.stringify(data),
    };
    return fetch(`${Url}multiempresa/rechazar_orden_unidad`, requestOptions)
        .then(HandleResponse)
        .then((response) => {

            return response;
        });
}

function despachar_orden_multiempresa(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...AuthHeader()
        },
        body: JSON.stringify(data),
    };
    return fetch(`${Url}multiempresa/despachar_orden`, requestOptions)
        .then(HandleResponse)
        .then((response) => {

            return response;
        });
}

function aceptar_orden_multiempresa(data) {
    return aceptar_orden(data);
}

function ordenesMultiempresa(data) {
    return fetch(
        `${Url}multiempresa/ordenes`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            },
            body: JSON.stringify(data)
        }
    ).then(HandleResponse);
}

function orden_logistica_multiempresa(data) {
    const requestOptions = {
        method: "POST",
        headers: AuthHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${Url}multiempresa/logistica_multiempresa`, requestOptions)
        .then(HandleResponse)
        .then((response) => {

            return response;
        });
}

function logisticaVentas(data) {
    const requestOptions = {
        method: "POST",
        headers: AuthHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${Url}multiempresa/logisticaVentas`, requestOptions)
        .then(HandleResponse)
        .then((response) => {

            return response;
        });
}

function retirar_logistica_multiempresa(data) {
    const requestOptions = {
        method: "POST",
        headers: AuthHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${Url}multiempresa/retirar_logistica_multiempresa`, requestOptions)
        .then(HandleResponse)
        .then((response) => {

            return response;
        });
}

function entregada_logistica_multiempresa(data) {
    const requestOptions = {
        method: "POST",
        headers: AuthHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${Url}multiempresa/entregada_logistica_multiempresa`, requestOptions)
        .then(HandleResponse)
        .then((response) => {

            return response;
        });
}

function devueltas_logistica_multiempresa(data) {
    const requestOptions = {
        method: "POST",
        headers: AuthHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${Url}multiempresa/devueltas_logistica_multiempresa`, requestOptions)
        .then(HandleResponse)
        .then((response) => {

            return response;
        });
}

function cambiar_cantidad_multiempresa(data) {
    const requestOptions = {
        method: "POST",
        headers: AuthHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${Url}multiempresa/cambiar_cantidad_multiempresa`, requestOptions)
        .then(HandleResponse)
        .then((response) => {

            return response;
        });
}

function rechazar_producto_logistica_multiempresa(data) {
    const requestOptions = {
        method: "POST",
        headers: AuthHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${Url}multiempresa/rechazar_producto_logistica`, requestOptions)
        .then(HandleResponse)
        .then((response) => {

            return response;
        });
}

function pagarSolicitudMultiempresa(data) {
    return fetch(`${Url}multiempresa/pagar_solicitud`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...AuthHeader()
        },
        body: JSON.stringify(data)
    })
        .then(async (response) => {
            const json = await response.json();

            if (!response.ok) {
                console.warn("[Frontend] error al pagar", json);
                throw new Error(json.message || "Error al pagar solicitud");
            }

            return json;
        })
        .catch((error) => {
            console.error("[Frontend] fallo en fetch pagarSolicitudMultiempresa", error);
            throw error;
        });
}

async function exportarOrdenesExcel(data) {
    const response = await fetch(`${Url}multiempresa/ordenes/exportar-excel`, {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        throw new Error("Error al exportar el archivo");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ordenes_multiempresa.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}



/** 
 * obtener solicitud 
 */
function obtenerMisSolicitudes(params = {}) {
    const query = new URLSearchParams(params).toString();

    return fetch(
        `${Url}multiempresa/mis_solicitudes?${query}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

function obtenerTodasLasSolicitudesJefe(params = {}) {
    const query = new URLSearchParams(params).toString();

    return fetch(
        `${Url}multiempresa/SolicitudesJefe?${query}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

function obtenerMisSolicitudesVendedor(params = {}) {
    const query = new URLSearchParams(params).toString();

    return fetch(
        `${Url}multiempresa/SolicitudesVendedor?${query}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

function obtenerProductosFrecuentes(id_empresa) {
    return fetch(
        `${Url}multiempresa/productos_frecuentes/${id_empresa}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

async function obtenerProductosAleatorios(idEmpresa) {
  if (!idEmpresa) throw new Error("idEmpresa es requerido");

  const requestOptions = { method: "GET" };

  return fetch(`${Url}multiempresa/publico/productos-aleatorios/${encodeURIComponent(idEmpresa)}`, requestOptions)
    .then(HandleResponse);
}

function obtenerSolicitudPorId(id) {
    return fetch(
        `${Url}multiempresa/solicitudes/${id}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

function obtenerSolicitudPorIdAdmin(id) {
    return fetch(
        `${Url}multiempresa/solicitudes_admin/${id}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

function eliminarSolicitud(id) {
    return fetch(`${Url}multiempresa/eliminar_solicitud/${id}`, {
        method: "DELETE",
        headers: {
            ...AuthHeader()
        }
    }).then(HandleResponse);
}

function obtenerSolicitudesAdmin(params = {}) {
    // Filtra los valores nulos o undefined
    const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v !== null && v !== undefined)
    );

    const query = new URLSearchParams(cleanParams).toString();
    const url = query
        ? `${Url}multiempresa/solicitudes_admin?${query}`
        : `${Url}multiempresa/solicitudes_admin`;

    return fetch(url, {
        method: "GET",
        headers: {
            ...AuthHeader()
        }
    }).then(HandleResponse);
}

function resumenSolicitudes() {
    return fetch(
        `${Url}multiempresa/contador_solicitudes`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

async function aprobarSolicitud(id) {
    const response = await fetch(
        `${Url}multiempresa/aprobar_solicitud/${id}`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            }
        }
    );

    const text = await response.text();
    const data = text ? JSON.parse(text) : {};

    if (!response.ok || data?.ok === false) {
        throw data;
    }

    return data;
}

function rechazarSolicitud(id, motivo) {
    return fetch(
        `${Url}multiempresa/rechazar_solicitud/${id}`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            },
            body: JSON.stringify({ motivo })
        }
    ).then(HandleResponse);
}

function exportarSolicitudesExcel(params = {}) {
    // Limpiar valores nulos o undefined
    const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v !== null && v !== undefined)
    );

    const query = new URLSearchParams(cleanParams).toString();
    const url = query
        ? `${Url}multiempresa/exportar_ecxel?${query}`
        : `${Url}multiempresa/exportar_ecxel`;

    return fetch(url, {
        method: "GET",
        headers: {
            ...AuthHeader()
        }
    })
        .then(async (response) => {
            if (!response.ok) throw new Error("Error descargando el Excel");

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = `Solicitudes_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '_')}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(downloadUrl);

            return true;
        });
}

async function descargarComprobante(urlArchivo, idSolicitud, identificacion) {
    try {
        const response = await fetch(`${Url}multiempresa/descargar-comprobante`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...AuthHeader()
            },
            body: JSON.stringify({ url: urlArchivo })
        });

        if (!response.ok) {
            throw new Error("No se pudo descargar el archivo del servidor.");
        }

        const blob = await response.blob();

        const blobUrl = window.URL.createObjectURL(blob);

        const extension = urlArchivo.split(/[#?]/)[0].split('.').pop().trim();

        const link = document.createElement('a');
        link.href = blobUrl;
        const idCliente = identificacion ? identificacion : 'SinID';
        link.download = `Comprobante_Solicitud_${idSolicitud}_${idCliente}.${extension}`;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        return true;

    } catch (error) {
        console.error("Error al descargar el comprobante:", error);
        throw error;
    }
}





/* Manejar pagos en reporteria del Usuario */
function procesarPagoClienteCorreo(id, metodo) {
    return fetch(`${Url}multiempresa/solicitud/${id}/pago-cliente-correo`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...AuthHeader()
        },
        body: JSON.stringify({
            metodo_pago: metodo
        })
    })
        .then(async (response) => {
            const json = await response.json();

            if (!response.ok) {
                console.warn("[Cliente] error al procesar pago", json);
                throw new Error(json.mensaje || "Error procesando pago del cliente");
            }

            return json;
        })
        .catch((error) => {
            console.error("[Cliente] fallo en procesarPagoClienteCorreo", error);
            throw error;
        });
}

function subirComprobanteCliente(id, archivo, metodo) {
    const formData = new FormData();
    formData.append("comprobante", archivo);
    formData.append("metodo_pago", metodo);

    const headers = AuthHeader();
    delete headers["Content-Type"];

    return fetch(`${Url}multiempresa/solicitud/${id}/comprobante-cliente`, {
        method: "POST",
        headers,
        body: formData
    })
        .then(async (response) => {
            const json = await response.json();

            if (!response.ok) {
                console.warn("[Cliente] error subiendo comprobante", json);
                throw new Error(json.mensaje || "Error subiendo comprobante del cliente");
            }

            return json;
        })
        .catch((error) => {
            console.error("[Cliente] fallo subirComprobanteCliente", error);
            throw error;
        });
}


/* Manejar perfil de empresa */
async function getPerfilEmpresa(idPerfil) {
    if (!idPerfil) throw new Error("idPerfil es requerido");

    const params = new URLSearchParams({ id_perfil: idPerfil });
    const requestOptions = { method: "GET", headers: AuthHeader() };

    return fetch(`${Url}multiempresa/perfil_empresa?${params.toString()}`, requestOptions)
        .then(HandleResponse);
}

async function getslugEmpresa(slug) {
    if (!slug) throw new Error("slug es requerido");

    const requestOptions = { method: "GET" };

    return fetch(`${Url}multiempresa/publico/empresa/${encodeURIComponent(slug)}`, requestOptions)
        .then(HandleResponse);
}

async function getEmpresasMultiempresa() {
    const requestOptions = {
        method: "GET",
        headers: AuthHeader(),
    };

    return fetch(`${Url}multiempresa/empresas`, requestOptions)
        .then(HandleResponse);
}

async function getEmpresasyPerfiles() {
    const requestOptions = {
        method: "GET",
        headers: AuthHeader(),
    };

    return fetch(`${Url}multiempresa/empresasyPerfiles`, requestOptions)
        .then(HandleResponse);
}

async function getEmpresasAsociadas() {
    const requestOptions = {
        method: "GET",
        //headers: AuthHeader(),
    };

    return fetch(`${Url}multiempresa/publico/ObtenerEmpresasAliadas`, requestOptions)
        .then(HandleResponse);
}


/* Logica para los productos */

async function obtenerProductos({
    empresa,
    categoria,
    subcategoria,
    marca,
    search,
    orden,
    precioMin,
    precioMax,
    page = 1,
    pageSize = 12,
}) {
    const params = new URLSearchParams();

    if (empresa) params.append("empresa", empresa);
    if (categoria) params.append("categoria", categoria);
    if (subcategoria) params.append("subcategoria", subcategoria);
    if (marca) params.append("marca", marca);
    if (search) params.append("search", search);
    if (orden) params.append("orden", orden);
    if (precioMin !== undefined) params.append("precioMin", precioMin);
    if (precioMax !== undefined) params.append("precioMax", precioMax);
    if (page) params.append("page", page);
    if (pageSize) params.append("pageSize", pageSize);

    const requestOptions = {
        method: "GET",
        headers: AuthHeader(),
    };

    return fetch(`${Url}multiempresa/productos?${params.toString()}`, requestOptions)
        .then(HandleResponse);
}

async function buscarProductosAutocomplete({ empresa, search }) {
    const params = new URLSearchParams();

    if (empresa) params.append("empresa", empresa);
    if (search) params.append("search", search);

    const requestOptions = {
        method: "GET",
        headers: AuthHeader(),
    };

    return fetch(`${Url}multiempresa/buscador?${params.toString()}`, requestOptions)
        .then(HandleResponse);
}

async function obtenerProductoPorId(id, { empresa }) {
    const params = new URLSearchParams();

    if (empresa) params.append("empresa", empresa);

    const requestOptions = {
        method: "GET",
        headers: AuthHeader(),
    };

    return fetch(`${Url}multiempresa/productos/${id}?${params.toString()}`, requestOptions)
        .then(HandleResponse);
}

async function categoriasPorEmpresa(empresa) {
    const params = new URLSearchParams();

    if (empresa) params.append("empresa", empresa);

    const requestOptions = {
        method: "GET",
        headers: AuthHeader(),
    };

    return fetch(`${Url}multiempresa/categorias?${params.toString()}`, requestOptions)
        .then(HandleResponse);
}

async function subcategoriasPorEmpresa(empresa, categoria) {
    const params = new URLSearchParams();

    if (empresa) params.append("empresa", empresa);
    if (categoria) params.append("categoria", categoria);

    const requestOptions = {
        method: "GET",
        headers: AuthHeader(),
    };

    return fetch(`${Url}multiempresa/subcategorias?${params.toString()}`, requestOptions)
        .then(HandleResponse);
}



/* Carro para la multiempresa */

function obtenerCarroF(sesion_usuario, empresa) {
    return fetch(
        `${Url}multiempresa/obtener?sesion_usuario=${encodeURIComponent(sesion_usuario)}&empresa=${encodeURIComponent(empresa)}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    )
        .then(HandleResponse)
        .then((response) => {
            const carrito = response?.carrito || {};
            const detalles = Array.isArray(carrito?.detalles) ? carrito.detalles : [];
            const detalleReferencia = detalles?.[0] || null;

            // Algunos responses no traen "cabecera" explícita, pero sí el id en carrito o en detalle.
            const cabeceraFallback = carrito?.cabecera || {
                id_cabecera_carro_ferreteros:
                    carrito?.id_cabecera_carro_ferreteros
                    ?? carrito?.id_cabecera_carro_ferretero
                    ?? carrito?.id_carro_ferretero
                    ?? detalleReferencia?.id_cabecera_carro_ferreteros
                    ?? detalleReferencia?.id_cabecera_carro_ferretero
                    ?? detalleReferencia?.id_carro_ferretero
                    ?? detalleReferencia?.id_cabecera_carro
                    ?? null,
                id_cabecera_carro_compra:
                    carrito?.id_cabecera_carro_compra
                    ?? detalleReferencia?.id_cabecera_carro_compra
                    ?? null,
            };

            return {
                ok: response?.ok ?? false,
                carrito: {
                    cabecera: cabeceraFallback,
                    detalles,
                    totales: carrito?.totales || {
                        subtotal: 0,
                        iva: 0,
                        total: 0
                    }
                }
            };
        });
}

function agregarProducto(data) {
    return fetch(
        `${Url}multiempresa/agregar`,
        {
            method: "POST",
            headers: {
                ...AuthHeader(),
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        }
    ).then(HandleResponse);
}

function actualizarProducto(data) {
    return fetch(
        `${Url}multiempresa/actualizar_producto`,
        {
            method: "POST",
            headers: {
                ...AuthHeader(),
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        }
    ).then(HandleResponse);
}

function eliminarProducto(data) {
    return fetch(
        `${Url}multiempresa/borrar_producto`,
        {
            method: "DELETE",
            headers: {
                ...AuthHeader(),
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        }
    ).then(HandleResponse);
}

function actualizar_stock_desde_solicitud(id, data = {}) {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...AuthHeader(),
        },
        body: JSON.stringify(data),
    };
    return fetch(`${Url}multiempresa/actualizar_stock_desde_solicitud/${id}`, requestOptions)
        .then(HandleResponse)
        .then((response) => {
            return response;
        });
}

function crear_stock_desde_solicitud(id, data = {}) {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...AuthHeader(),
        },
        body: JSON.stringify(data),
    };
    return fetch(`${Url}multiempresa/crear_stock_desde_solicitud/${id}`, requestOptions)
        .then(HandleResponse)
        .then((response) => {
            return response;
        });
}

/**
 * Clientes
 */
function MasSolicitadosCliente(id_empresa) {
    return fetch(
        `${Url}Cliente_tenant/MasSolicitados/${id_empresa}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

function obtenerMisSolicitudesCliente(params = {}) {
    const query = new URLSearchParams(params).toString();

    return fetch(
        `${Url}Cliente_tenant/MisSolicitudes?${query}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

function SolicitudClientePorId(id) {
    return fetch(
        `${Url}Cliente_tenant/Mis_Solicitudes/${id}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}


function obternerConfiguracionUsuario(id) {
    return fetch(
        `${Url}Cliente_tenant/ConfiguracionUsuario/${id}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

function obtenerTiposDocumentosCredito() {
    return fetch(
        `${Url}Cliente_tenant/Obtener_tipo_documento`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

function crearSolicitudCredito(data) {
    return fetch(
        `${Url}Cliente_tenant/Crear_solicitud_apertura`,
        {
            method: "POST",
            headers: {
                ...AuthHeader(null)
            },
            body: data
        }
    ).then(HandleResponse);
}

function obtenerSolicitudesApertura(queryString = "") {
    return fetch(
        `${Url}Cliente_tenant/Obtener_Solicitudes_Apertura${queryString}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

function obtenerDetalleSolicitudApertura(id) {
    return fetch(
        `${Url}Cliente_tenant/Obtener_Detalle_Solicitud_Apertura/${id}`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}

function evaluarSolicitudApertura(id, data) {
    return fetch(
        `${Url}Cliente_tenant/Evaluar_Solicitud_Apertura/${id}`,
        {
            method: "POST",
            headers: {
                ...AuthHeader(),
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }
    ).then(HandleResponse);
}

function obtenerPlazosEmpresas() {
    return fetch(
        `${Url}Cliente_tenant/Plazos_Empresas`,
        {
            method: "GET",
            headers: {
                ...AuthHeader()
            }
        }
    ).then(HandleResponse);
}





/**
 * CORE EMPRESAS EXTERNAS
 */
function crearSolicitudMultiTenant(data) {
    return fetch(
        `${Url}multiempresa/crear_solicitud-empresa`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            },
            body: JSON.stringify(data)
        }
    ).then(HandleResponse);
}

async function aprobarSolicitudMultiTenant(id) {
    const response = await fetch(
        `${Url}multiempresa/aprobarSolicitud-empresa/${id}`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            }
        }
    );

    const text = await response.text();
    const data = text ? JSON.parse(text) : {};

    if (!response.ok || data?.ok === false) {
        throw data;
    }

    return data;
}

function rechazarSolicitudMultiTenant(id, motivo) {
    return fetch(
        `${Url}multiempresa/rechazarSolicitud-empresa/${id}`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            },
            body: JSON.stringify({ motivo })
        }
    ).then(HandleResponse);
}


